import PinContents from '@activities/easyCard/common/PinContents';
import PinKeyboard from '@activities/easyCard/common/PinKeyboard';
import Column from '@components/Column';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useEasyCardPayment from './hooks/useEasyCardPayment';

interface Params {
    orderNo: string;
    cardId: string;
}

declare module '@stackflow/config' {
    interface Register {
        OrderEasyCardPinActivity: Params;
    }
}

/** 간편카드 결제 비밀번호 입력. 6자리를 모두 입력하면 바로 결제를 요청한다 */
const OrderEasyCardPinActivity: ActivityComponentType<'OrderEasyCardPinActivity'> = ({ params }) => {
    const { t } = useTranslation('order');
    const {
        pin, attempt, useBio, changePin, handleUseBioChange,
    } = useEasyCardPayment(params);
    return (
        <AppScreen>
            <Column fullWidth fullHeight>
                <Header title={t('easyCardPin.title')} />
                <PinContents pin={pin}
                    useBio={useBio}
                    onUseBioChange={handleUseBioChange}
                    alwaysShowUseBio/>
                <PinKeyboard pin={pin}
                    onPinChange={changePin}
                    shuffleKey={attempt}/>
            </Column>
        </AppScreen>
    );
};

export default OrderEasyCardPinActivity;
